import { FormControl, FormHelperText, FormLabel, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useLoggedInWithOrgContextState } from "../../../../../common/auth/useLoggedInWithOrgContextState";
import { organizationHasSeveralDepartments } from "../../../../../common/departments/departmentVisibility";
import { useContractState } from "../../useContractState";

export const Department = () => {
  const { t } = useTranslation();
  const authState = useLoggedInWithOrgContextState();
  const department = useContractState().contract.department;

  if (!organizationHasSeveralDepartments(authState.selectedOrg) || !department) return null;

  return (
    <FormControl id="department">
      <FormLabel>{t("Department")}</FormLabel>
      <Text>{department.name}</Text>
      <FormHelperText>{t("The department a contract belongs to is set when it is created")}</FormHelperText>
    </FormControl>
  );
};
